import React from "react";
import SessionListNewContainer from "../../../components/adm/session/sessionListNew";
import Layout from "../../../components/layouts/verticalLayout";

const SessionListNewPage = () => {
  return <Layout body={<SessionListNewContainer />} />;
};

export default SessionListNewPage;
